import { render, staticRenderFns } from "./RechercheParArticle.vue?vue&type=template&id=5c4cc6a8&"
import script from "./RechercheParArticle.vue?vue&type=script&lang=js&"
export * from "./RechercheParArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports